import {
  GenderLabAppShell,
  GenderLabLoader,
  LessonContent,
} from "../../components";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Flex,
  Button,
  Text,
} from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { aulaService } from "../../api";
import { TEnrollmentProgress, TProgress, TModule, TLesson } from "../../types/Aula";
import { useMediaQuery } from "@mantine/hooks";
import { SatisfactionSurveyPage } from "../SatisfactionSurveyPage";
import { QuizPage } from "../QuizPage";
import { Outline } from "../../components/Outline";

export const LessonContentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, lessonId } = useParams();
  const state = location.state;

  const [enrollment, setEnrollment] = useState<TEnrollmentProgress | null>(
    null
  );
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [progress, setProgress] = useState<TProgress[]>([]);
  const [isEnrollmentActive, setIsEnrollmentActive] = useState<boolean | null>(
    null
  );

  const modules = enrollment?.course.modules;
  const isCompleted = useMemo(() => {
    return progress.some((p) => p.lesson === lessonId && p.completed_at !== null);
  }, [progress, lessonId]);
  const isLessonAccessible = useMemo(() => {
    return progress.some((p) => p.lesson === lessonId && p.is_accesible);
  }, [progress, lessonId]);

  const getEnrollmentById = async (id: string) => {
    if (enrollment !== null) setEnrollment(null);
    if (progress.length > 0) setProgress([]);
    const response = await aulaService.getEnrollmentProgressById(id);
    setEnrollment(response.data.enrollment);
    setProgress(response.data.progress);
    const isActive = new Date() <= new Date(response.data.enrollment.end_date);
    setIsEnrollmentActive(isActive);
  };

  const findNextLesson = (
    lessonId: string,
    modules: TModule[]
  ): TLesson | null => {
    let found = false;
    for (const module of modules) {
      for (const lesson of module.lessons) {
        if (found) return lesson;
        if (lesson.id === lessonId) found = true;
      }
    }
    return null;
  };

  const renderLessonContent = () => {
    if (isEnrollmentActive === false) {
      return <Text size="lg" fw={700}>Esta inscripción al curso no se encuentra activa.</Text>;
    }
    if (isLessonAccessible === false) {
      return <Text size="lg" fw={700}>Aún no puedes acceder a esta clase. Completa las clases anteriores.</Text>;
    }
    
    if (state?.category === "satisfaction_survey") {
      return <SatisfactionSurveyPage nextLesson={findNextLesson(lessonId!, enrollment!.course.modules)} />;
    }
    if (state?.category === "quiz") {
      return <QuizPage nextLesson={findNextLesson(lessonId!, modules!)} />;
    }
  
    return (
      <LessonContent
        enrollmentId={id!}
        lessonId={lessonId!}
        nextLesson={findNextLesson(lessonId!, modules!)}
        isCompleted={isCompleted}
      />
    );
  };

  const checkLessonAccess = () => {
    if (isEnrollmentActive === false) {
      return (
        <Text size="lg" fw={700}>
          Esta inscripción al curso no se encuentra activa.
        </Text>
      );
    } else if (isLessonAccessible === false) {
      return (
        <Text size="lg" fw={700}>
          Aún no puedes acceder a esta clase. Completa las clases anteriores.
        </Text>
      );
    } else {
      return renderLessonContent();
    }
  };
  

  useEffect(() => {
    if (lessonId && id && (state?.lessonCompleted || enrollment === null)) {
      getEnrollmentById(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonId]);
  
  return (
    <GenderLabAppShell
      navbar={
        <Outline
          enrollment={enrollment}
          progress={progress}
          lessonId={lessonId!}
        />
      }
    >
      {id && lessonId && enrollment ? (
        <Flex direction="column" align="center" gap="sm">
          <Button
            onClick={() => navigate(`/aula-virtual/${enrollment.id}`)}
            style={{ alignSelf: "flex-start", marginTop: isMobile ? "3rem" : "2rem" }}
            variant="subtle"
          >
            Volver al Inicio
          </Button>
          {checkLessonAccess()}
        </Flex>
      ) : (
        <GenderLabLoader />
      )}
    </GenderLabAppShell>
  );
  
};
